import React from "react";
import { useWatch } from 'react-hook-form';
const MyDebugField = (props) => {
    const record = useWatch();
    return (<div>{JSON.stringify(record)}</div>);
}
export default MyDebugField;